import React from 'react';
import { Box, Divider, VStack, HStack } from 'native-base';
import dayjs from 'dayjs';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { RedeemedResponse, resizedUrl, useTheme } from '@springbig/shared';
import { SpIcon } from '~/shared/Icon';
import Image from '~/shared/Image';
import { Caption } from '~/shared/Typography';
import { Panel, Card } from '~/shared/Theme';

const AccountHistoryRedemptionCard = ({ redeemed }: { redeemed: RedeemedResponse }) => {

    const {
        primary,
    } = useTheme();

    return (
        <Panel mb={4}>
            <VStack
                alignItems={'center'}
                space={4}
            >
                <Caption>
                    { dayjs(redeemed.transaction_date).format('MM/DD/YYYY h:mm a') }
                </Caption>
                <Divider
                    bg={primary}
                />
                <HStack
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    w={'100%'}
                    space={2}
                >
                    <Card
                        secondary
                        p={0}
                        w={20}
                        h={20}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        {
                            redeemed.display_image ? (
                                <Image uri={resizedUrl(redeemed.display_image, 80, 80)} />
                            ) : (
                                <SpIcon
                                    color={primary}
                                    icon={faStar}
                                    size={60}
                                />
                            )
                        }
                    </Card>
                    <Caption>
                        { redeemed.reward_name }
                    </Caption>
                    <Box textAlign={'center'}>
                        <Caption>
                            { parseInt(redeemed.item_value || '0') }
                            <Caption text='history.points' ml={1} />
                        </Caption>
                        <Caption text='history.redeemed' />
                    </Box>
                </HStack>
            </VStack>
        </Panel>
    );
};

export default AccountHistoryRedemptionCard;
